exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price[data-v-f456d17a] {\n  text-decoration: line-through;\n  font-weight: 400;\n  font-size: 14px;\n  padding-top: 2px;\n}\n.offer-price[data-v-f456d17a] {\n  font-size: 17px;\n}\n.quantity[data-v-f456d17a] {\n  padding-top: 2px;\n  font-size: 17px;\n}", ""]);

// exports
